import { BrowserModule } from '@angular/platform-browser'
import { inject, NgModule, provideZoneChangeDetection } from '@angular/core'

import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools'
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core'
import { CoreModule } from '@app/core'
import { SharedModule } from '@app/shared'
import { environment } from '@env'
import { SessionModule } from '@app/session/session.module'
import { UserModule } from '@app/user/user.module'
import { registerAngularLocales } from '@app/locale-registration'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { HttpLoaderFactory } from './providers/app-translate-loader'

// Register locales used in the application, we need these for number formatting.
// Remember to add locales to the client when adding new languages to Flexit!
registerAngularLocales()

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule,
    SharedModule.forRoot(),
    BrowserAnimationsModule,
    SessionModule,
    UserModule,
    AppRoutingModule,
  ],
  providers: [
    // Angular 21+ defaults to zoneless; this app still relies on zone.js-triggered change detection.
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    ...provideTranslateService({
      loader: provideTranslateLoader(() => HttpLoaderFactory(inject(HttpClient))),
    }),
  ],
})
export class AppModule {}
